import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaLink
} from "react-icons/fa";
import '../../../styles/Soc.css';

const SocialMedia = () => {
  const location = useLocation();
  const sectionRefs = useRef({});
  const platformData = {
    title: "Social Media",
    description: "Social media platforms and management services",
    icon: "📢",
    color: "#3b82f6",
    sections: [
      {
        id: "facebook",
        title: "Facebook",
        smicon: <FaFacebookF />,
        description: "Social media presence and management on Facebook",
        items: ["ReadersMenu", "TodayTalks", "FirstLook"],
        features: [
          "Page management",
          "Content scheduling",
          "Audience engagement",
          "Analytics tracking"
        ],
        images: [
          "/assets/fbimages/rm.png",
          "/assets/fbimages/tt.png",
          "/assets/fbimages/fl.png"
        ],
        pageLinks: [
          { name: "ReadersMenu", url: "https://www.facebook.com/profile.php?id=61563438916723" },
          { name: "TodayTalks", url: "https://www.facebook.com/profile.php?id=61563928347546" },
          { name: "FirstLook", url: "https://www.facebook.com/profile.php?id=61565105135784" }
        ],
        insights: "50K+ followers, 85% engagement rate",
        managementLink: "https://business.facebook.com"
      },
      {
        id: "youtube",
        smicon: <FaYoutube />,
        title: "YouTube",
        description: "Video content and channel management",
        items: ["ReadersMenu", "MakkalNaatkaati"],
        features: [
          "Channel management",
          "Video optimization",
          "Content strategy",
          "Audience growth"
        ],
        images: [
          "/assets/ytimg/rm.png",
          "/assets/ytimg/mn.png"
        ],
        pageLinks: [
          { name: "ReadersMenu", url: "https://youtube.com/@readers_menu?si=EHxdhlCvlVGZyPHa" },
          { name: "MakkalNaatkaati", url: "https://youtube.com/@makkalnaatkaati?si=9e1ahPvqeoK16lxD" }
        ],
        insights: "21K+ subscribers, 500k+ monthly views",
        managementLink: "https://studio.youtube.com"
      },
      {
        id: "instagram",
        title: "Instagram",
        smicon: <FaInstagram />,
        description: "Visual content and engagement platform",
        items: ["ReadersMenu", "TodayTalks", "Mpeoples", "Mpeoples Attrocites", "FirstLook"],
        features: [
          "Visual content creation",
          "Story management",
          "Reels optimization",
          "Engagement tracking"
        ],
        images: [
          "/assets/igimg/mp.png",
          "/assets/igimg/rm.png",
          "/assets/igimg/tt.png",
          "/assets/igimg/fl.png",
        ],
        pageLinks: [
          { name: "@readersmenu", url: "https://www.instagram.com/readers_menu?igsh=bml4emczZXU5ZXV6" },
          { name: "@todaytalks", url: "https://www.instagram.com/todaytalks_official?igsh=NWk1dXN4Y2cyODk1" },
          { name: "@mpeoples", url: "https://www.instagram.com/mpeoples_official?igsh=dnpibzNmMmtsc3Bo" },
          { name: "@firstlook", url: "https://www.instagram.com/firstlo_ok?igsh=MWk3NTBpN3F6cWdyeg==" }
        ],
        insights: "1K+ followers, 90% engagement rate",
        managementLink: "https://business.instagram.com"
      }
    ]
  };
  const [activeImageIndex, setActiveImageIndex] = useState(() => {
    const initialIndices = {};
    platformData.sections.forEach(section => {
      initialIndices[section.id] = 0;
    });
    return initialIndices;
  });

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && sectionRefs.current[hash]) {
      setTimeout(() => {
        sectionRefs.current[hash].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
  }, [location.hash]);

  const nextImage = (sectionId) => {
    const currentIndex = activeImageIndex[sectionId];
    const totalImages = platformData.sections.find(s => s.id === sectionId).images.length;
    setActiveImageIndex({
      ...activeImageIndex,
      [sectionId]: (currentIndex + 1) % totalImages
    });
  };

  const prevImage = (sectionId) => {
    const currentIndex = activeImageIndex[sectionId];
    const totalImages = platformData.sections.find(s => s.id === sectionId).images.length;
    setActiveImageIndex({
      ...activeImageIndex,
      [sectionId]: (currentIndex - 1 + totalImages) % totalImages
    });
  };

  const goToImage = (sectionId, index) => {
    setActiveImageIndex({
      ...activeImageIndex,
      [sectionId]: index
    });
  };

  return (
    <div className="platform-page4">
      {/* Hero Section */}
      <div
        className="platform-hero4"
        style={{ "--hero-color": platformData.color }}
      >
        <div className="platform-hero-content4">

          <span className="platform-eyebrow4">
            {platformData.category || "Solution Details"}
          </span>

          <h1>{platformData.title}</h1>

          <p className="platform-description4">
            {platformData.description}
          </p>

          <div className="platform-meta4">
            <span>Enterprise Ready</span>
            <span>Secure by Design</span>
            <span>High Performance</span>
          </div>

          <div className="platform-hero-actions">
            <a href="/contact" className="btn-primary">Get Started</a>
          </div>
        </div>
        <img className='bannerimgmob' src="/assets/opbg/smside.jpg" alt="" />
      </div>


      {/* Sections */}
      <div className="platform-sections4">
        <div className="sections-container4">
          <div className="sections-sidebar4">
            <h3>Sections</h3>
            <ul className="section-nav4">
              {platformData.sections.map((section, index) => (
                <li key={index}>
                  <div className='smicon'>{section.smicon}</div>
                  <a
                    href={`#${section.id}`}
                    className="section-nav-link4"
                    style={{ '--hover-color': platformData.color }}
                  >
                    {section.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sections-content4">
            {platformData.sections.map((section, index) => (
              <section
                key={index}
                id={section.id}
                ref={el => sectionRefs.current[section.id] = el}
                className="platform-section4"
              >
                <div className="section-header4">
                  <h2>{section.title}</h2>
                </div>
                <p className="section-description4">{section.description}</p>

                {/* Image Carousel Section */}
                <div className="section-carousel4">
                  <h4>Platform Showcase</h4>
                  <div className="carousel-container4">
                    <div className="carousel-wrapper4">
                      <button
                        className="carousel-btn4 prev-btn4"
                        onClick={() => prevImage(section.id)}
                        style={{ backgroundColor: platformData.color }}
                      >
                        ‹
                      </button>

                      <div className="carousel-image-container4">
                        <img
                          src={section.images[activeImageIndex[section.id] || 0]}
                          alt={`${section.title} showcase ${(activeImageIndex[section.id] || 0) + 1}`}
                          className="carousel-image4"
                          loading="lazy"
                        />
                        <div className="image-indicator4">
                          {section.images.map((_, imgIndex) => (
                            <button
                              key={imgIndex}
                              className={`indicator-dot4 ${(activeImageIndex[section.id] || 0) === imgIndex ? 'active' : ''}`}
                              onClick={() => goToImage(section.id, imgIndex)}
                              style={{
                                backgroundColor: (activeImageIndex[section.id] || 0) === imgIndex
                                  ? platformData.color
                                  : '#ccc'
                              }}
                            />
                          ))}
                        </div>
                      </div>

                      <button
                        className="carousel-btn4 next-btn4"
                        onClick={() => nextImage(section.id)}
                        style={{ backgroundColor: platformData.color }}
                      >
                        ›
                      </button>
                    </div>

                    <div className="carousel-thumbnails4">
                      {section.images.map((image, imgIndex) => (
                        <button
                          key={imgIndex}
                          className={`thumbnail4 ${(activeImageIndex[section.id] || 0) === imgIndex ? 'active' : ''}`}
                          onClick={() => goToImage(section.id, imgIndex)}
                        >
                          <img
                            src={image}
                            alt={`Thumbnail ${imgIndex + 1}`}
                            loading="lazy"
                          />
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Social Media Insights */}
                <div className="social-insights4">
                  <div className="insight-card4" style={{ backgroundColor: `${platformData.color}10`, borderColor: platformData.color }}>
                    <span className="insight-icon4" style={{ color: platformData.color }}>📊</span>
                    <div className="insight-content4">
                      <div className="insight-title4">Platform Insights</div>
                      <div className="insight-text4">{section.insights}</div>
                    </div>
                  </div>
                </div>

                {/* Social Media Links */}
                <div className="section-links4">
                  <h4>Managed Pages/Channels</h4>
                  <div className="social-links-container4">
                    {section.pageLinks.map((page, pageIndex) => (
                      <div
                        className="social-link4"
                        style={{
                          backgroundColor: `${platformData.color}10`,
                          borderLeftColor: platformData.color
                        }}
                      >
                        <span className="social-icon4" style={{ color: platformData.color }}>
                          {section.id === 'facebook' ? <FaFacebookF /> :
                            section.id === 'youtube' ? <FaYoutube /> :
                              section.id === 'instagram' ? <FaInstagram /> :
                                <FaLink />}
                        </span>
                        <div className="social-link-content4">
                          <a href={page.url} target='_blank' className="social-link-name4">{page.name}</a>
                          {/* <a href={page.url} target='_blank' className="social-link-url4">{page.url}</a> */}
                        </div>
                        <span className="social-link-arrow4" style={{ color: platformData.color }}> <a href={page.url} target='_blank'> <FaLink /> </a></span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="section-features4">
                  <h4>Management Features</h4>
                  <ul className="features-list4">
                    {section.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>
                        <div className="feature-icon4" style={{ color: platformData.color }}>
                          ✓
                        </div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="section-items4">
                  <h4>Brand Accounts</h4>
                  <ul className="items-grid4">
                    {section.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="item-card4"
                        style={{ borderLeftColor: platformData.color }}
                      >
                        <div className="item-bullet4" style={{ backgroundColor: platformData.color }}></div>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="section-cta4">
                  <a
                    href={section.managementLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cta-button4"
                    style={{
                      backgroundColor: platformData.color,
                      display: 'inline-block',
                      textDecoration: 'none',
                      textAlign: 'center'
                    }}
                  >
                    Explore {section.title} Page
                  </a>
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;